import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseService} from "projects/nter-ui-kit/src/lib/framework/common/base.service";
import {ApplicationForm} from 'projects/soko-console-web-v2/src/app/core/model/retailer/application-form.model';
import {environment} from 'projects/soko-console-web-v2/src/environments/environment';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ApplicationFormsService extends BaseService {
  baseUrl: string = environment.apiRetailersHost + '/console/offering/district/settings/application-forms';

  constructor(private http: HttpClient) {
    super();
  }

  public getAllFormTemplatesForCurrentOffering(): Observable<ApplicationForm[]> {
    return this.http.get<ApplicationForm[]>(this.baseUrl);
  }

  public deleteOneFormTemplate(formTemplateUuid: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${formTemplateUuid}`);
  }

  public setOneFormTemplateAsActive(formTemplateUuid: string): Observable<ApplicationForm[]> {
    return this.http.post<ApplicationForm[]>(`${this.baseUrl}/${formTemplateUuid}/activate`, null);
  }

  public getOneTemplate(formTemplateUuid: string): Observable<ApplicationForm> {
    return this.http.get<ApplicationForm>(`${this.baseUrl}/${formTemplateUuid}`);
  }

  public duplicateForm(uuid: string | null): Observable<ApplicationForm> {
    return this.http.post<ApplicationForm>(`${this.baseUrl}/${uuid}/duplicate`, null);
  }
}
